import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import React from 'react';

const InputPhone: React.FC<PhoneInputProps> = ({ ...rest }) => {
  return <PhoneInput {...rest} />;
};
export default InputPhone;
